export default {"subscriptionCardContainer":"b0MWr","tabsList":"D-5d-","textContainer":"_7vkOC"};